<div class="search-box">
  <fa-icon
    class="search-icon"
    [icon]="faSearch"
    (click)="isAdvancedSearch ? openHistrory() : null"
  ></fa-icon>
  <input
    type="text"
    [formControl]="searchControl"
    [placeholder]="placeholder ?? ('search-input.input.search' | translate)"
    (keydown.enter)="onEnter()"
    (blur)="markTouched()"
  />
  <div class="remove" [class.visible]="deleteIconVisible">
    <fa-icon
      class="reset"
      [icon]="['fas', 'filter-circle-xmark']"
      (click)="resetFilter()"
    ></fa-icon>
  </div>
</div>
